import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 5.072a8 8 0 1 1 -3.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 3.995 -6.643z","key":"svg-0"}]]

/**
 * IconPlayerRecordFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItcGxheWVyLXJlY29yZCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNOCA1LjA3MmE4IDggMCAxIDEgLTMuOTk1IDcuMjEzbC0uMDA1IC0uMjg1bC4wMDUgLS4yODVhOCA4IDAgMCAxIDMuOTk1IC02LjY0M3oiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/player-record-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPlayerRecordFilled = createReactComponent('filled', 'player-record-filled', 'PlayerRecordFilled', __iconNode);

export default IconPlayerRecordFilled;